var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconRetiroPendiente(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 88,
    height: 90,
    viewBox: "0 0 88 90",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_5791_59159)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 3,
    width: 78,
    height: 80,
    rx: 16,
    fill: "#F9B400"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39 49.5453V52.818H42.3333V54.4544H45.6666V52.818C47.5 52.818 49 51.3453 49 49.5453V47.909C49 46.109 47.5 44.6363 45.6666 44.6363H42.3333V42.9999H49V39.7272H45.6666V38.0908H42.3333V39.7272C40.5 39.7272 39 41.1999 39 42.9999V44.6363C39 46.4362 40.5 47.909 42.3333 47.909H44H45.6666V49.5453H39Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24 41.3636H30.6667V38.0909H27.3333V28.2727H60.6667V38.0909H57.3333V41.3636H64V25H24V41.3636Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.6666 61V34.8181H57.3333V31.5454H30.6665V34.8181H32.3332V61H55.6666ZM52.3333 57.7273H35.6665V34.8181H52.3333V57.7273Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_5791_59159",
    x: 0,
    y: 0,
    width: 88,
    height: 90,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_5791_59159"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_5791_59159",
    result: "shape"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconRetiroPendiente);
export default __webpack_public_path__ + "static/media/icon_retiro_pendiente.a41fc7c123b216d1c094422b90ef7f6b.svg";
export { ForwardRef as ReactComponent };